export const resize = (file, maxDimenssions) => {
    let w;
    let h;
    let ratio;
    if(maxDimenssions.width) {
        w = Math.min(file.width, maxDimenssions.width);
        ratio = w / file.width;
        h = file.height * ratio;
    } else if(maxDimenssions.height) {
        h = Math.min(file.height, maxDimenssions.height);
        ratio = h / file.height;
        w = file.width * ratio;
    } else {
        return file;
    }

    let canvas = document.createElement('canvas');
    let context = canvas.getContext('2d');
    canvas.width = w;
    canvas.height = h;

    context.drawImage(file, 0, 0, w, h);

    const img = canvas.toDataURL();

    return img;
}